import { createSelector } from '@ngrx/store';

import { onlineOrderState } from '../root';

export const isZeroDolarPayment = createSelector(
    onlineOrderState,
    onlineOrder => onlineOrder?.data?.TotalLeftToPay === 0
);
